import { retrieveReports as apiretrieveReports } from '@/api/api'
import { ApiReport } from './builders/ApiReport'

export default {

  RETRIEVE_LIST: ({ commit }) => {
    return apiretrieveReports().then(res => {
      const reports = res.response.data.map(report => new ApiReport.Builder(report).build())
      commit('SET_REPORTS', { reports })
    }).catch(error => Promise.reject(error))
  },
}
